module.exports = __webpack_public_path__ + "img/data.afc90fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/blockChain/data.png
// module id = Aw7m
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37